module.exports = __webpack_public_path__ + "media/images/map/current-location-41bf79239a44011a1ec3e7ece05db561.svg";